import { PERSISTED_STATE_STORAGE_KEYS } from '@app/component/web-storage/useWebStorage';
import { createJSONStorage, persist } from 'zustand/middleware';
import Principal from '@app/model/authentication/Principal';
import { LANGUAGE } from '@app/component/translation/Language';
import { createWithEqualityFn } from 'zustand/traditional';
import { clearSentryUser, setSentryUser } from '@util/SentryHelper';

export interface SiteState {
	principal: Principal | undefined,
	setPrincipal: (principal: Principal | null) => void,
	token: string | undefined,
	setToken: (token: string | undefined) => void,
	language: LANGUAGE,
	setLanguage: (language: LANGUAGE) => void,
	afterLoginPath?: string,
	setAfterLoginPath: (path: string | undefined) => void
	logout: () => void,
	expirationDate: Date | undefined,
	setExpirationDate: (inSeconds: number) => any,
	selectedCompanyHotelId: number | undefined,
	setSelectedCompanyHotelId: (companyHotelId: number | undefined) => void
}

const useSiteState = createWithEqualityFn(
	persist<SiteState>(
		set => ({
			principal: undefined,
			setPrincipal: (principal: Principal | null) => {
				if (principal) setSentryUser({ id: String(principal.id), username: principal.username });
				else clearSentryUser();
				set({ principal: principal ?? undefined });
			},
			token: undefined,
			setToken: (token: string) => set({ token: token }),
			language: LANGUAGE.ENGLISH,
			setLanguage: (language: LANGUAGE) => set({ language: language }),
			logout: () => {
				clearSentryUser();
				set({ principal: undefined, token: undefined });
			},
			setAfterLoginPath: (path: string) => set({ afterLoginPath: path }),
			expirationDate: undefined,
			setExpirationDate: (inSeconds: number) => {
				const expirationDate = new Date();
				expirationDate.setSeconds(expirationDate.getSeconds() + inSeconds);
				set({ expirationDate: expirationDate });
			},
			selectedCompanyHotelId: undefined,
			setSelectedCompanyHotelId: (companyHotelId: number) => set({ selectedCompanyHotelId: companyHotelId })

		}), {
			name: PERSISTED_STATE_STORAGE_KEYS.SITE_STATE,
			storage: createJSONStorage(() => localStorage),
		}),
);

export default useSiteState;
